<div class="cronograma-fungicidas">
  <div class="container-fluid wrapper-content">
    <div class="ibox">
      <div class="ibox-title">
        <h2 class="title">
          Cronograma de Fungicidas
        </h2>
        <div
          class="ibox-tools"
          ng-if="$root.permissions.recomendacao.canManage"
        >
          <button type="button" class="btn btn-primary" ng-click="$ctrl.createNew()">
            <i class="fa fa-plus"></i>
            Novo
          </button>
        </div>
      </div>
      <div class="ibox-content">
        <div class="row">
          <div class="col-xs-4">
            <div class="form-group">
              <label for="filter-safra" class="control-label">Safra</label>
              <select
                name="filter-safra"
                id="filter-safra"
                class="form-control"
                ng-options="safra.descricao for safra in $root.safras track by safra.id"
                ng-model="$ctrl.safra"
                ng-change="$ctrl.loadSchedules()"
              ></select>
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label for="filter-atividade" class="control-label">Atividade</label>
              <select
                name="filter-atividade"
                id="filter-atividade"
                class="form-control"
                ng-options="atividade.descricao for atividade in $ctrl.atividades track by atividade.id"
                ng-model="$ctrl.atividade"
                ng-change="$ctrl.loadSchedules()"
              >
                <option value="">Todas</option>
              </select>
            </div>
          </div>
          <div class="col-xs-4">
            <div class="row">
              <div class="col-xs-11">
                <div class="form-group">
                  <label for="filter-gleba" class="control-label">Talhão</label>
                  <select
                    name="filter-gleba"
                    id="filter-gleba"
                    class="form-control"
                    ng-options="gleba.descricao for gleba in $root.currentPropriedade.glebas track by gleba.id"
                    ng-model="$ctrl.gleba"
                    ng-change="$ctrl.loadSchedules()"
                  >
                    <option value="">Todas</option>
                  </select>
                </div>                
              </div>
              <div class="col-xs-1 no-padding">
                <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
                  <button type="button" class="btn">
                    <i class="fa fa-print"></i>
                  </button>

                  <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
                    <li role="menuitem">
                      <a ng-click="$ctrl.reportDemandaUso($event)" href="#">Demanda de uso de insumos</a>
                    </li>
                  </ul>
                </div>                
              </div>
            </div>                       
          </div>
        </div>
        <div class="row">
            <div class= "col-xs-4">
              <div class="box box-green"></div>
              <div>Aplicado</div>
            </div>
            <div class= "col-xs-4">
              <div class="box box-stripped"></div>
              <div>Em andamento</div>
            </div>
            <div class= "col-xs-4">
              <div class="box box-yellow"></div>
              <div>3 Dias para a aplicação</div>
            </div>
          </div>
        <p></p>
          <div class="row">
            <div class= "col-xs-4">
              <div class="box box-red"></div>
              <div>Atrasado</div>
            </div>
            <div class= "col-xs-4">
              <div class="box box-gray"></div>
              <div>Dentro do prazo</div>
            </div>
            <div class= "col-xs-4">
              <div class="box box-gray strikethrough"></div>
              <div><s>Não será realizada a aplicação</s></div>
            </div>
          </div>
      </div>
    </div>

    <p class="text-cinza text-center" ng-show="$ctrl.loading">
      <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando cronogramas...
    </p>
    <div class="text-cinza text-center" ng-show="!$ctrl.loading && $ctrl.schedules.length === 0">
      <h3>
        <i class="fa fa-calendar-times-o"></i>
        Nenhum cronograma encontrado
      </h3>
      <p ng-if="$root.permissions.recomendacao.canManage">Clique em Novo para adicionar um cronograma.</p>
    </div>
    <cronograma-fungicidas-grid
      schedules="$ctrl.schedules"
      on-update="$ctrl.loadSchedules()"
    ></cronograma-fungicidas-grid>
  </div>
</div>
